import ApassExternalPersonnelSelect from './src/main';

/* istanbul ignore next */
ApassExternalPersonnelSelect.install = function(Vue) {
  Vue.component(ApassExternalPersonnelSelect.name, ApassExternalPersonnelSelect);
};

export default ApassExternalPersonnelSelect;
